import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import NProgress from '../utils/nprogress';

export const useNProgress = () => {
  const location = useLocation();
  const timerRef = useRef(null);
  const finishTimerRef = useRef(null);
  const progressRef = useRef(0);

  useEffect(() => {

    if (location.pathname.toLowerCase() === '/settings') {
      return;
    }
    
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    if (finishTimerRef.current) {
      clearTimeout(finishTimerRef.current);
    }

    progressRef.current = 0.3;
    NProgress.set(0.3);
    
    timerRef.current = setInterval(() => {
      progressRef.current += 0.1;
      if (progressRef.current < 0.9) {
        NProgress.set(progressRef.current);
      }
    }, 100);

    finishTimerRef.current = setTimeout(() => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      NProgress.done();
      progressRef.current = 0;
      finishTimerRef.current = null;
    }, 800);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      if (finishTimerRef.current) {
        clearTimeout(finishTimerRef.current);
        finishTimerRef.current = null;
      }
      NProgress.done(true);
      progressRef.current = 0;
    };
  }, [location.pathname]);
};